import React, { useState } from 'react';
import GroupIcon from '@mui/icons-material/Group';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import TranslateIcon from '@mui/icons-material/Translate';
import TranslationsView from './Translations/TranslationsView';
import UserMenuPopover from './UserMenuPopover';

import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

import PetsIcon from '@mui/icons-material/Pets';
import TerminalIcon from '@mui/icons-material/Terminal';
import SchoolIcon from '@mui/icons-material/School';
import CategoryIcon from '@mui/icons-material/Category';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';

import Commands from './Commands/Commands';
import Courses from './Courses/Courses';
import SpeciesAndBreeds from './SpeciesAndBreeds/SpeciesAndBreeds';
import TrainersList from './Trainers/TrainersList';
import { useAuth } from '../providers/auth/AuthContext';
import CourseCategoryList from './CourseCategories/CourseCategoryList';
import HealthCheckItemList from './HealthCheckItems/HealthCheckItemList';
import InsuranceProviders from './InsuranceProviders/InsuranceProviders';
import Sports from './Sports/Sports';
import PredefinedTasks from './PredefinedTasks/PredefinedTasks';

const drawerWidth = 70;

const views = [
    { label: 'Species and Breeds', icon: <PetsIcon />, component: <SpeciesAndBreeds /> },
    { label: 'Commands', icon: <TerminalIcon />, component: <Commands /> },
    { label: 'Course Categories', icon: <CategoryIcon />, component: <CourseCategoryList /> },
    { label: 'Health Check Items', icon: <MedicalServicesIcon />, component: <HealthCheckItemList /> },
    { label: 'Insurance Providers', icon: <BusinessIcon />, component: <InsuranceProviders /> },
    { label: 'Sports', icon: <SportsSoccerIcon />, component: <Sports /> },
    { label: 'Predefined Tasks', icon: <AssignmentIcon />, component: <PredefinedTasks /> },
    { label: 'Courses', icon: <SchoolIcon />, component: <Courses /> },
    { label: 'Trainers', icon: <GroupIcon />, component: <TrainersList /> },
    { label: 'Translations', icon: <TranslateIcon />, component: <TranslationsView /> },
];

function Main() {
    const { logout } = useAuth();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(null);
    // Example user info, replace with real user data as needed
    const user = { name: 'John Doe', email: 'john.doe@email.com' };

    const handleUserIconClick = (event: React.MouseEvent<HTMLElement>) => {
        setUserMenuAnchorEl(event.currentTarget);
    };
    const handleUserMenuClose = () => {
        setUserMenuAnchorEl(null);
    };
    const handleLogout = () => {
        setUserMenuAnchorEl(null);
        logout();
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 0,
                    },
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <List>
                        {views.map((view, idx) => (
                            <ListItem key={view.label} disablePadding sx={{ justifyContent: 'center' }}>
                                <Tooltip title={view.label} placement="right">
                                    <ListItemButton
                                        selected={selectedIndex === idx}
                                        onClick={() => setSelectedIndex(idx)}
                                        sx={{ display: 'flex', justifyContent: 'center', minHeight: 56 }}
                                    >
                                        {view.icon}
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                {/* User icon at the very bottom */}
                <Box sx={{ width: '100%', mb: 2 }}>
                    <List>
                        <ListItem disablePadding sx={{ justifyContent: 'center' }}>
                            <Tooltip title="User" placement="right">
                                <ListItemButton
                                    sx={{ display: 'flex', justifyContent: 'center', minHeight: 56 }}
                                    onClick={handleUserIconClick}
                                >
                                    <PersonIcon />
                                </ListItemButton>
                            </Tooltip>
                        </ListItem>
                    </List>
                    <UserMenuPopover
                        anchorEl={userMenuAnchorEl}
                        open={Boolean(userMenuAnchorEl)}
                        onClose={handleUserMenuClose}
                        user={user}
                        onLogout={handleLogout}
                    />
                </Box>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1 }}>
                {views[selectedIndex].component}
            </Box>
        </Box>
    );
}

export default Main;